import React, { useState, useContext } from "react";
import { QuizContext } from "../../../assets/context/index";
import "./styled.css";

const questions = [
  {
    option: "a) Experiência de Usuário Final que gere Upsell",
    correct: false,
  },
  {
    option: "b) Experiência Onipresente para o Usuário Final",
    correct: true,
  },
  {
    option: "c) Experiência Super Abrangente para o Usuário Final",
    correct: false,
  },
  {
    option: "d) Experiência Singular para o Usuário Final",
    correct: false,
  },
  {
    option: "e) Experiência Expansiva para o Usuário Final",
    correct: false,
  },
];

export default function Question38(props) {
  const { t } = useContext(QuizContext);
  const { setQuestionSelected, checkAnswers } = props;
  const [optionSelected, setOptionSelected] = useState("");

  function selectOption(option) {
    setOptionSelected(option.option);

    setQuestionSelected((state) => {
      return {
        ...state,
        question38: {
          title:
            "A filosofia da Stefanini para Digital Workplace Services é proporcionar?",
          option: option.option,
          correct: option.correct,
          order: 38,
        },
      };
    });
  }
  return (
    <div style={{ marginTop: 30 }}>
      <h5 style={{ textAlign: "center" }}>
        {t(
          "A filosofia da Stefanini para Digital Workplace Services é proporcionar?"
        )}
      </h5>

      <div className="div-options-question-ste">
        {questions.map((e, i) => (
          <a
            key={i}
            className={`option-question-ste ${
              optionSelected === e.option && "selected-option-question-ste"
            } ${checkAnswers && (e.correct ? "check-true" : "check-false")}`}
            onClick={() => {
              if (!checkAnswers) {
                selectOption(e);
              }
            }}
          >
            {t(e.option)}
          </a>
        ))}
      </div>
    </div>
  );
}
